import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledWrapperHeader = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const SectionHeading = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
